import React, { memo } from 'react';

import { Link } from 'react-router-dom';

import { StyledRelatedPosts } from './styles';
import { Heading11, Paragraph8 } from '../../../theme';
import { bemClassName } from '../../../utils/bem';
import { TagRounded } from '../../atoms/tag-rounded';

const b = bemClassName('related-posts');

const RelatedPosts = ({ posts }) => {
  if (!posts || posts.length === 0) return null;

  return (
    <StyledRelatedPosts>
      <div className={b()}>
        <div className={b('title')}>
          <Heading11>You May Also Like</Heading11>
        </div>
        <div className={b('grid')}>
          {posts.map((post) => (
            <Link key={post._id || post.slug} to={`/blog/${post.slug}`} className={b('card')}>
              {post.coverImageUrl && (
                <div className={b('card-image')}>
                  <img src={post.coverImageUrl} alt={post.title} loading="lazy" />
                </div>
              )}
              <div className={b('card-body')}>
                {post.category && (
                  <div className={b('card-category')}>
                    <TagRounded text={post.category} />
                  </div>
                )}
                <div className={b('card-title')}>
                  <Paragraph8>{post.title}</Paragraph8>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </StyledRelatedPosts>
  );
};

export default memo(RelatedPosts);
